import { SelectControl } from "@wordpress/components";
import { useState, useEffect, useRef } from "react";
import { __, sprintf } from "@wordpress/i18n";
const declOfNum = (number, titles) => {
  var cases = [2, 0, 1, 1, 1, 2];
  return (
    number +
    " " +
    titles[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ]
  );
};
const MethodDescription = (props) => {
  const { billing, data, eventRegistration, emitResponse } = props;
  // console.log("MethodDescription", data);

  const { onPaymentSetup } = eventRegistration;
  const total = billing?.cartTotal?.value ?? 0;
  const currency = billing?.currency ?? {
    code: "UAH",
    symbol: "грн.",
    thousandSeparator: "",
    decimalSeparator: ".",
    minorUnit: 2,
    prefix: "",
    suffix: " грн.",
  };

  // Функция форматирования суммы
  const formatAmount = (amount) => {
    return (
      currency.prefix +
      (amount / Math.pow(10, currency.minorUnit)).toFixed(currency.minorUnit) +
      currency.suffix
    );
  };
  const l_ = {'II': __('Мгновенная рассрочка', 'themewoocommerce-pr_join'), 'PP': __('Оплата частями', 'themewoocommerce-pr_join'), 'PB': __('Оплата частями. Деньги в периоде', 'themewoocommerce-pr_join'), 'IA': __('Мгновенная рассрочка. Акционная', 'themewoocommerce-pr_join')}
  // Опции для SelectControl
  const selectMerchantTypeName = Object.entries(data.merchantTypeName).map(([value, label]) => ({
    value,
    label: l_[value],
  }));
   // Состояние для выбранного типа мерчанта
 const [selectedMerchant, setSelectedMerchant] = useState("II");
 // Состояние для количества платежей
 const [partsCount, setPartsCount] = useState(Number(saphaliSettingsPrivatBank.partsCountName["II"]));
 // Функция обновления количества платежей
 const handlePartsChange = (event) => {
  const newParts = Math.max(2, Math.min(maxParts, Number(event.target.value)));
  setPartsCount(newParts);
};


  useEffect(() => {
    const unsubscribe = onPaymentSetup(async () => {
      console.log(partsCount, selectedMerchant);
      
      return {
        type: emitResponse.responseTypes.SUCCESS,
        meta: {
          paymentMethodData: {
            partforclient: String(partsCount), // передача кастомных данных
            merchantType: String(selectedMerchant), // передача кастомных данных
          },
        },
      };
    });

    return () => {
      unsubscribe();
    };
  }, [partsCount, selectedMerchant]);
  

 
   // Определяем максимальное количество платежей
   const maxParts = Number(saphaliSettingsPrivatBank.partsCountName[selectedMerchant] || 10);
  return (
    (data.partforclient && maxParts > 1 && (
      <div className="method-description">
        {/* <p>{__("Выберите количество платежей:", "themewoocommerce-pr_join")}</p> */}
        <fieldset classname="form-group">
          <SelectControl
            label={__(
              "Выберите предпочитаемый тип",
              "themewoocommerce-pr_join"
            )}
            name="merchantType"
            value={selectedMerchant}
            options={selectMerchantTypeName}
            onChange={(newValue) => {
              setSelectedMerchant(newValue);
              setPartsCount(Number(saphaliSettingsPrivatBank.partsCountName[newValue]));
              console.log("newValue, selectedMerchant: ", newValue, selectedMerchant);
          }}
            variant="default"
            __nextHasNoMarginBottom={true}
          />  
        </fieldset>
          {/* Поле для ввода количества платежей */}
          <div className="main_block_part">
                {__('Количество платежей', 'themewoocommerce-pr_join')} <span className="partforclient_max">({sprintf(__('максимально %s', 'themewoocommerce-pr_join'),  declOfNum(maxParts, [
          __("платеж", "themewoocommerce-pr_join"),
          __("платежа", "themewoocommerce-pr_join"),
          __("платежей", "themewoocommerce-pr_join"),
        ]))})</span>: 
                <input
                    name="partforclient"
                    style={{ maxWidth: "60px" }}
                    type="number"
                    className="partforclient"
                    value={partsCount}
                    max={maxParts}
                    min="2"
                    step="1"
                    onChange={handlePartsChange}
                />
            </div>

        {/* Текст с расчётом платежей */}
        <p>
          {sprintf(
            __("Вы платите: %s x %s %s", "themewoocommerce-pr_join"),
            partsCount,
            formatAmount(total / partsCount), 
            __('+ % по кредиту', "themewoocommerce-pr_join")
          )}
        </p>
      </div>
    )) || (
      <div>
        <p>{data.description}</p>
      </div>
    )
  );
};

export default MethodDescription;
